(function () {
    'use strict';

    angular
        .module('completeAir')

        .factory('tariffClassService', tariffClassService);

    tariffClassService.$inject = ['$http', 'CONFIG', 'messageService'];

    function tariffClassService($http, CONFIG, messageService) {

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/fareClasses';

        var service = {
            getFareClasses: getFareClasses,
            saveFareClass: saveFareClass,
            getFareClass: getFareClass,
            updateFareClass: updateFareClass,
            deleteFareClass: deleteFareClass,
            thereFareClassName: thereFareClassName,
            thereFareClassIataCode: thereFareClassIataCode,
            getCabins: getCabins,
            getClasses: getClasses,
            getFareClassesFare: getFareClassesFare
        };

        return service;

        function getFareClasses() {
            return $http.get(urlBase + "?detailed=true")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response) ? response : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function saveFareClass(fareClass) {
            return $http.post(urlBase, fareClass)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete() {
                messageService.register('');
            }

            function getFailed() {
                messageService.registerError('');
            }
        }

        function getFareClass(id) {
            return $http.get(urlBase + "/" + id+ "?detailed=true")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                return (response) ? response : [];
            }

            function getFailed() {
                messageService.findAllError('');
            }
        }

        function updateFareClass(id, fareClass) {
            return $http.put(urlBase + "/" + id, fareClass)
                .then(function (response) {
                    messageService.registerUpdate('')
                    return response;
                })
                .catch(function (error) {
                    messageService.findAllError('');
                });
        }

        function deleteFareClass(id) {
            return $http.delete(urlBase + "/" + id)
                .then(function(response){
                    messageService.register('');
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('regions','air.fareClass.associatedClasses')
                    }else{
                        messageService.registerDeleteError('')
                    }
                });

                //.then(deleteComplete)
                //.catch(getFailed);

            function deleteComplete() {
                messageService.register('');
            }

            function getFailed() {
                messageService.registerError('');
            }
        }

        function deleteRegion(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(response){
                    messageService.registerDelete('regions')
                    return response;
                })
                .catch(function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('regions','air.region.associatedCities')
                    }else{
                        messageService.registerDeleteError('region')
                    }
                });
        }

        function thereFareClassName(fareClassName) {
            return $http.get(urlBase + "/" + "thereFareClassName/" + fareClassName, {headers: {'Loading-Overlay': false}})
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAError('')
                });
        }

        function thereFareClassIataCode(thereFareClassIataCode) {
            return $http.get(urlBase + "/" + "thereFareClassIataCode/" + thereFareClassIataCode, {headers: {'Loading-Overlay': false}})
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAError('')
                });
        }

        function getCabins(){
            return $http.get(CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + "/" + "categories")
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAError('')
                });
        }

        function getClasses(id){
            if (typeof id != 'undefined'){
                return $http.get(CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + "/" + "categories/" + id + "/classes")
                    .then(function (response) {
                        return response;
                    })
                    .catch(function () {
                        messageService.findAError('')
                    });
            }
        }

        function getFareClassesFare(){
            return $http.get(CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + "/categories/classesFare")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.categories : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }
    }

})();

